import React, { useState, useRef, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import { Form, Input, Button, Alert, Card, Spin, Row, Typography } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import SimpleReactValidator from "simple-react-validator";
import AuthServices from "../../services/AuthServices";

import "simple-react-validator/dist/locale/es";
import { translate, get_language } from "../../locale";
import FullPageLoader from "../../components/Loaders/FullPageLoader";
import PrimaryButton from "../../components/Buttons/PrimaryButton";

const { Text } = Typography;

const VerificationCode = () => {
  const { username, code } = useParams();
  const token = AuthServices.getToken();
  const [values, setValues] = useState({
    username: username ? username : "",
    code: code ? code : "",
    password: "",
  });
  const [loading, setLoading] = useState(false);
  const [validating, setValidating] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState("");
  const [, forceUpdate] = useState();

  const simpleValidator = useRef(
    new SimpleReactValidator({
      locale: get_language,
      autoForceUpdate: { forceUpdate: forceUpdate },
      element: (message) => (
        <div className="text-red-600 pt-2 text-xs">{message}</div>
      ),
      validators: {
        sameValue: {
          message: translate("Las contraseñas no coinciden"),
          rule: (val, params, validator) => val === params[0],
          required: true,
        },
      },
    })
  );

  const disabled = () => !simpleValidator.current.allValid();

  useEffect(() => {
    if (token !== null && token !== "" && code !== "") {
      const data = {
        hash: code,
      };
      verifyCode(data, true);
    }
  }, [token, code]);

  const verifyCode = async (data, prevLogin) => {
    // prevLogin = true, si ya estaba logueado anteriormente
    if (prevLogin) {
      setValidating(true);
    }
    try {
      const res = await AuthServices.verifyInvite(data);
      if (
        res &&
        res.status !== undefined &&
        res.status >= 200 &&
        res.status < 300 &&
        res.data
      ) {
        setValues({
          username: "",
          password: "",
          code: "",
        });
        simpleValidator.current.hideMessages();
        simpleValidator.current.visibleFields = [];
        forceUpdate();

        /* message.success(translate("El código fue verificado exitosamente."));
        if (prevLogin) {
          navigate("/admin");
        } else {
          window.location.href = "/admin";
        } */
        setSuccess(true);
      } else {
        if (prevLogin) {
          /* message.error(translate("El código no es correcto."), 30);
          navigate("/admin"); */
        } else {
          setError(res.data.message);
        }
      }
      if (prevLogin) {
        setValidating(false);
      }
    } catch (e) {
      console.log(e.message);
      if (e.message !== "") {
        setError(e.message);
      }
      if (prevLogin) {
        setValidating(false);
      }
    }
  };

  const onFinish = async () => {
    setLoading(true);
    setError("");
    if (!simpleValidator.current.allValid()) {
      simpleValidator.current.showMessages();
      forceUpdate();
      setError("El usuario y/o contraseña son incorrectos.");
      return;
    }
    try {
      const dataSignIn = {
        username: values.username,
        password: values.password,
      };
      const resSignIn = await AuthServices.signIn(dataSignIn);
      if (
        resSignIn &&
        resSignIn.status !== undefined &&
        resSignIn.status >= 200 &&
        resSignIn.status < 300 &&
        resSignIn.data
      ) {
        AuthServices.setToken(resSignIn.data.access_token);
        AuthServices.setRefreshToken(resSignIn.data.refresh_token);
        AuthServices.setUser(values.username);
        const data = {
          hash: values.code,
        };
        verifyCode(data);
        /* const res = await AuthServices.verifyInvite(data);
        
        if (
          res &&
          res.status !== undefined &&
          res.status >= 200 &&
          res.status < 300 &&
          res.data
        ) {
          setValues({
            username: "",
            password: "",
            code: "",
          });

          message.success(translate("El código fue verificado exitosamente."));
          window.location.href = "/admin";
        } else {
          setError(res.data.message);
        } */
      } else {
        setError("El usuario y/o contraseña son incorrectos.");
      }
      setLoading(false);
    } catch (e) {
      console.log(e.message);
      if (e.message !== "") {
        setError(e.message);
      }
      setLoading(false);
    }
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setValues((v) => ({ ...v, [name]: value }));
  };

  const handleBlur = (e) => {
    const { name, value } = e.target;
    simpleValidator.current.showMessageFor(name);
    setValues((v) => ({ ...v, [name]: value }));
  };

  return (
    <div className="flex flex-row w-screen justify-center items-stretch min-h-full max-w-7xl py-24">
      <div className="w-full md:w-1/2 flex justify-center">
        <Card
          title={translate("Verificar Código")}
          className="w-full lg:w-7/12"
          bordered={false}
          headStyle={{ border: "none" }}
        >
          {!validating && !success && (
            <>
              <Text style={{ top: "-16px", position: "relative" }}>
                {translate("Ingrese su contraseña para validar el código")}
              </Text>

              {error && (
                <Alert
                  message={error}
                  type="error"
                  className="mb-6"
                  closable
                  onClose={() => setError("")}
                />
              )}

              <Form
                // initialValues={{ username: values.username }}
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                autoComplete="off"
                className="w-full"
              >
                <Form.Item>
                  <Input
                    placeholder={translate("Nombre de usuario")}
                    className="border-custom_primary"
                    name="username"
                    disabled={true}
                    value={values.username}
                  />
                </Form.Item>
                <Form.Item>
                  <Input
                    placeholder={translate("Código")}
                    className="border-custom_primary"
                    name="code"
                    disabled={true}
                    value={values.code}
                  />
                </Form.Item>

                <Form.Item>
                  <Input.Password
                    placeholder={translate("Contraseña")}
                    className="border-custom_primary"
                    name="password"
                    onChange={handleChange}
                    onBlur={handleBlur}
                  />
                  {simpleValidator.current.message(
                    "password",
                    values.password,
                    "required|min:7",
                    get_language === "es"
                      ? {
                          messages: {
                            required: "El campo Contraseña es requerido",
                            min: "El tamaño de Contraseña debe ser de al menos :min caracteres.",
                          },
                        }
                      : {}
                  )}
                </Form.Item>

                <Row justify="end">
                  <Button
                    disabled={disabled() || loading}
                    htmlType="submit"
                    type="primary"
                    className="bg-custom_primary"
                  >
                    {loading && (
                      <Spin
                        indicator={
                          <LoadingOutlined style={{ color: "#666666" }} />
                        }
                        className="mr-2"
                      />
                    )}
                    {translate("Aceptar")}
                  </Button>
                </Row>

                <Row className="mt-20">
                  <Link to="/auth/login" className="mb-4">
                    {translate("Ya tengo cuenta")}
                  </Link>
                </Row>
              </Form>
            </>
          )}
          {!validating && success && (
            <>
              <Text style={{ top: "-16px", position: "relative" }}>
                {translate("Su código ha sido verificado exitosamente.")}
              </Text>
              <PrimaryButton
                onClick={() => {
                  window.location.href = "/admin";
                }}
              >
                {translate("Continuar")}
              </PrimaryButton>
            </>
          )}
        </Card>
      </div>
      {validating && <FullPageLoader />}
    </div>
  );
};

export default VerificationCode;
